module.exports = __webpack_public_path__ + "img/masait_no.ce12c503.png";